var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H9.5C9.224 3 9 3.224 9 3.5C9 3.776 9.224 4 9.5 4H11.793L8.6465 7.1465C8.45125 7.34175 8.45125 7.65825 8.6465 7.8535C8.74425 7.95125 8.872 8 9 8C9.128 8 9.25575 7.95125 9.3535 7.8535L12.5 4.707V7C12.5 7.276 12.724 7.5 13 7.5C13.276 7.5 13.5 7.276 13.5 7V3.5C13.5 3.224 13.276 3 13 3Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6465 9.14644L3.5 12.2929V9.99994C3.5 9.72394 3.276 9.49994 3 9.49994C2.724 9.49994 2.5 9.72394 2.5 9.99994V13.4999C2.5 13.7759 2.724 13.9999 3 13.9999H6.5C6.776 13.9999 7 13.7759 7 13.4999C7 13.2239 6.776 12.9999 6.5 12.9999H4.207L7.3535 9.85344C7.54875 9.65819 7.54875 9.34169 7.3535 9.14644C7.1585 8.95119 6.8415 8.95119 6.6465 9.14644Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.359e75125ad70253b132fe86e91f0bad.svg";
export { ForwardRef as ReactComponent };